import { useNavigate } from "react-router-dom";

type DelaysAvailableProps = {
  value?: number;
  meta?: Partial<{
    avgDays: number;
    count: number;
    minDays: number;
    maxDays: number;
  }>;
};

const DelaysAvailable = ({
  value = 0,
  meta = {},
}: DelaysAvailableProps) => {
  const navigate = useNavigate();

  const avgDays =
    typeof meta.avgDays === "number" ? meta.avgDays : 0;
  const maxDays =
    typeof meta.maxDays === "number" ? meta.maxDays : 0;

  const indicator = typeof value === "number" ? value : 0;
  const pulseColor =
    indicator > 0 ? "animate-pulse-color" : "";


  const handleClick = () => {
    const statusUrl = `/operational-management?situation=DELAYED&status=available`;

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      navigate(statusUrl);
    } else {
      window.open(statusUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className={`relative bg-white border border-gray-200 shadow-md rounded-2xl p-5 transition hover:shadow-lg hover:scale-[1.01] font-semibold ${pulseColor}`}
      id="card-delays-available"
      aria-live="polite"
    >
      <div className="grid grid-cols-[1fr_auto] gap-4 items-center justify-center">
        <div className="flex flex-col justify-center items-center">
          <div className="mb-2 flex items-center gap-2">
            <h3 className={`text-xl font-semibold ${indicator > 0 ? 'text-white' : 'text-black'}`}>
              Disponíveis com Atrasos
            </h3>
          </div>
          <a
            onClick={handleClick}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline hover:text-blue-500 cursor-pointer"
          >

            <p className={`text-3xl font-semibold ${indicator > 0 ? 'text-white' : 'text-black'}`}>
              {value.toLocaleString("pt-BR")}
            </p>
          </a>

          <p className={`mt-2 ${indicator > 0 ? 'text-white' : 'text-black'}`}>
            Média de Dias:{" "}
            {Math.round(avgDays)}
            <br />
          </p>

          <p className={`${indicator > 0 ? 'text-white' : 'text-black'}`}>
            Maior tempo: {Math.round(maxDays)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DelaysAvailable;
